<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import _find from 'lodash/find'
import _extend from 'lodash/extend'
import _uniq from 'lodash/uniq'

import CANNABIS_TYPES from 'constants/cannabisTypes'
import CANNABIS_TYPE_NAMES from 'constants/cannabisTypeNames'
import VENUE_ORDER_PICK_UP_TYPE_NAMES from 'constants/venueOrderPickUpTypeNames'
import * as mutationTypes from 'store/mutationTypes'
import store from 'store'
import stringUtils from 'utils/stringUtils'

export default {
  name: 'order-sidebar',
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
      filters: (state) => state.orderFilters.filters,
      inventory: (state) => state.inventory.current,
    }),
    venuePickUpString() {
      if (!this.venue.orderPickUpTypes || !this.venue.orderPickUpTypes.length) return null

      const types = this.venue.orderPickUpTypes.map((type) => VENUE_ORDER_PICK_UP_TYPE_NAMES[type])

      if (types.length === 1) {
        return types[0]
      }

      return types.map((t) => `<span class="type">${t}</span>`).join(' and ')
    },
    venueOpenStatus() {
      if (!this.venue) return ''

      let today = new Date().getDay()
      const isAfterMidnight = new Date().getHours() < 6

      if (isAfterMidnight) {
        today -= 1

        if (today < 0) {
          today = 6
        }
      }

      const todaysSchedule = _find(this.venue.schedule, function (scheduleDay) {
        return scheduleDay.day === today
      })

      if (!todaysSchedule) return ''
      if (todaysSchedule.closed) return '<span class="open-status-label closed">Closed</span>'
      if (!todaysSchedule.hours[0].start || !todaysSchedule.hours[0].end) return ''

      const start = todaysSchedule.hours[0].start
      const end = todaysSchedule.hours[0].end

      const startDate = moment.utc(start)
      const endDate = moment.utc(end)

      // const dayName = utils.getDayName(today);

      return `<span class="open-status-label open">Store hours</span>
        <span class="time">${startDate.format('h:mm a')}</span> -
        <span class="time">${endDate.format('h:mm a')}</span>`
    },
    cannabisTypes() {
      return Object.keys(CANNABIS_TYPES).map((key) => {
        return {
          key: CANNABIS_TYPE_NAMES[key],
          value: key,
        }
      })
    },
    showDiscountFilter() {
      return true
    },
    brands() {
      if (!this.inventory || !this.inventory.length) return []

      return _uniq(this.inventory.map((inv) => stringUtils.capitalize(inv.brand))).sort()
    },
  },
  watch: {
    filterForm: {
      deep: true,
      handler(val) {
        if (val) {
          this.$store.dispatch('setCurrentOrderFilters', val)
        }
      },
    },
  },
  data() {
    return {
      CANNABIS_TYPES,
      CANNABIS_TYPE_NAMES,
      filterForm: {
        cannabisTypes: [],
        discountValue: true,
        search: null,
        brand: null,
      },
    }
  },
  methods: {
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SET_CURRENT_ORDER_FILTERS || mutation.type === mutationTypes.REMOVE_CURRENT_ORDER_FILTERS) {
        _extend(this.filterForm, this.filters)
      }
    },
  },
  mounted() {
    this.storeUnsubscribe = store.subscribe(this.onMutation)

    _extend(this.filterForm, this.filters)
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/OrderSidebar/index.vue